import { useState, useCallback } from 'react';
import { useFetch } from './useFetch';
import { API_CONFIG } from '../config/api';

interface DeleteState {
  isLoading: boolean;
  error: string | null;
  success: boolean;
}

export const useContentDelete = () => {
  const [state, setState] = useState<DeleteState>({
    isLoading: false,
    error: null,
    success: false,
  });

  const { fetchWithAuth } = useFetch();

  const deleteContent = useCallback(async (contentId: string): Promise<boolean> => {
    setState(prev => ({ ...prev, isLoading: true, error: null, success: false }));
    
    try {
      const response = await fetchWithAuth(`${API_CONFIG.BASE_URL}/contents/${contentId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro ao deletar conteúdo: ${response.status} - ${errorText}`);
      }

      setState(prev => ({
        ...prev,
        isLoading: false,
        success: true,
      }));

      return true;
    } catch (error) {
      setState(prev => ({
        ...prev,
        error: error instanceof Error ? error.message : 'Erro desconhecido',
        isLoading: false,
      }));
      return false;
    }
  }, [fetchWithAuth]);

  const resetState = () => {
    setState({
      isLoading: false,
      error: null,
      success: false,
    });
  };

  return {
    deleteContent,
    isLoading: state.isLoading,
    error: state.error,
    success: state.success,
    resetState,
  };
};


